import React, { useState } from 'react'
import styles from '../styles/color/index.module.scss'
import { Row, Col, Affix, message, Card, Tooltip, Spin, List } from 'antd'
import Layout from '../../components/MyLayout'
import { NextPage, NextPageContext } from 'next';
import { useSelector } from 'react-redux'
import { State } from '../../@types/reducer'
import { useRouter } from 'next/router'
import Navigation from '../../components/Color/Navigation';
import { Item, Palette } from '../../@types/color';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadOne } from '@icon-park/react';
import dynamic from 'next/dynamic';
import Meta from 'antd/lib/card/Meta';
import CopyToClipboard from 'react-copy-to-clipboard';
import IPalette from '../../components/Color/Palette';
const SearchNoSSR = dynamic(() => import('../../components/Color/Search'), {
  ssr: false
})

type UploadProps = {
  list: {
    key: string | string[]
    total: number
    list: Item[]
  }
  type: number
  page: number
  limit: number
  by: string | string[]
  imgUrl: string | string[]
  text: string | string[]
}

const Upload: NextPage<UploadProps> = () => {
  const head = {
    title: `传图生成调色板-上传图片一键生成专业调色板`,
    keywords: `生成调色板,插画调色板,照片调色板`,
    description: `上传图片智能生成调色板，可实时提取插画调色板、网页调色板、UI调色板、电商调色板、照片调色板、风景图片调色板等等。并且可以编辑色调以及色值，以图片形式导出调色板。自动匹配中文传统色色彩名称。`
  }
  const router = useRouter()
  const [list, setList] = useState<Palette[] | []>([]);
  const [loading, setLoading] = useState(false);
  const { baseUrl, userInfo } = useSelector((state: State) => state)
  const props = {
    name: 'file',
    multiple: false,
    action: baseUrl + '/api/v1/color/getColors',
    showUploadList: false,
    data: { userId: userInfo.id },
    beforeUpload(file: { type: string; size: number; }) {
      setLoading(true)
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        setLoading(false)
        message.error('只能上传 JPG/PNG 文件!');
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        setLoading(false)
        message.error('图片大小不能超过 5MB!');
      }
      return isJpgOrPng && isLt5M;
    },
    onChange(info: { file: { name?: any; response?: any; status?: any; }; fileList: any; }) {
      setLoading(false)
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        if (info.file.response.code == 200) {
          message.success(`${info.file.name} 文件上传成功`);
          let item: any = [info.file.response.data, ...list]
          setList(item)
        } else {
          message.success(`${info.file.name} 文件上传错误`);
        }
      } else if (status === 'error') {
        message.error(`${info.file.name} 文件上传错误`);
      }
    },
    onDrop(e: { dataTransfer: { files: any; }; }) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  return (
    // <WindowScroller serverWidth={1920} serverHeight={1080}>
    //   {({ height, isScrolling, onChildScroll, scrollTop }) => (
    <Layout className={styles.color} head={head}>
      <div className="content">
        <Affix offsetTop={0}>
          <div style={{ minHeight: '38px' }}><SearchNoSSR /></div>
        </Affix>
        <Row className="items">
          <Col xs={7} sm={7} md={5} lg={5} xl={3}>
            <Navigation />
          </Col>
          <Col className="page upload" xs={17} sm={17} md={19} lg={19} xl={21} style={{ minHeight: '400px' }}>
            <Row style={{ justifyContent: 'center', marginTop: '20px' }}>
              <Spin tip="努力分析中..." spinning={loading}>
                <Dragger {...props}>
                  <p className="ant-upload-drag-icon">
                    <UploadOne theme="outline" size="35" fill="#333" strokeWidth={3} />
                  </p>
                  <p className="ant-upload-text">上传图片,一键生成调色板</p>
                  <p className="ant-upload-hint">
                    支持上传jpg/png，文件大小不超过5M。禁止上传违规文件
                  </p>
                </Dragger>
              </Spin>
            </Row>
            <Row style={{ justifyContent: 'center', marginTop: '20px' }}>
              <List
                itemLayout="vertical"
                size="large"
                dataSource={list}
                footer={null}
                renderItem={item => (
                  <IPalette item={item} />
                )} />
            </Row>
          </Col>
        </Row>
      </div>
    </Layout >
    //   )}
    // </WindowScroller>
  )
}

// Upload.getInitialProps = async ({ req, res, err, query }: NextPageContext) => {
//   const text = query.text || ""
//   const page = query.p || 1;
//   const by = query.by || 'update_date'
//   const limit = 40
//   const type = 2
//   const data: any = await http(colorList, {
//     type,
//     limit,
//     page,
//     by,
//     key: text,
//   })
//   const list: any = data.data
//   if (list.code == -202 && res) {
//     res.writeHead(404)
//     res.end()
//   }
//   console.log(list)
//   return {
//     list: list.data,
//     page: Number(page),
//     imgUrl: list.data.imgUrl,
//     limit,
//     by,
//     text,
//     type
//   }
// }

export default Upload